define([
    "angular",
    "./addressModule"
], function (angular, addressModule) {
    "use strict";
    addressModule.provider("viaCepServiceUrl", [function () {

        var addressByZipCode;

        this.$get = [function () {
            return {
                getAddressByZipCode: getAddressByZipCode
            };
        }];

        function getAddressByZipCode() {
            return addressByZipCode;
        }

        this.configure = function (server) {
            addressByZipCode = server.addressByZipCode;
        };
    }]);
});

